// extracted by mini-css-extract-plugin
export default {"form-action-message":"FormMessage_form-action-message__3Bnzt"};